import React from 'react';
import { Dialog, DialogActions, Button, Typography, TextField, useTheme } from '@mui/material';
import { LeaveActivity } from 'app/shared/reducers/activity/activity-actions';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import toast from 'react-hot-toast';
import { fetchBookMarkedItems } from 'app/shared/reducers/profile';
import { filterActivities } from 'app/shared/reducers/activity-filter';

const LeaveActivityRecurringDialog = ({ open, onClose, handleData }) => {
  const [leaveReason, setLeaveReason] = React.useState('');
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector(state => state.leaveActivityReducer);

  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  const handleReport = async () => {
    const params = {
      activityIds: handleData,
      message: leaveReason ? leaveReason : '',
    };

    try {
      const postResponse = await dispatch(LeaveActivity(params));
      if (postResponse.payload != undefined) {
        toast.success('Left succesfully');
      } else {
        toast.error('Status not updated');
      }

      setLeaveReason('');
      onClose();
    } catch (error) {
      toast.error('Something Went Wrong');
      console.error(error);
    }
  };

  const handleCancel = () => {
    setLeaveReason('');
    onClose();
  };


  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="xs" fullWidth>
      <style>
        {

          `.css-iueg6m-MuiPaper-root-MuiDialog-paper { border-radius: 15px !important }`
        }
        {`.css-cl4rap-MuiPaper-root-MuiDialog-paper { border-radius: 15px !important}`}

      </style>
      <div style={{ padding: '16px' }}>
        <Typography variant="h6" gutterBottom>
          Leave Activity
        </Typography>
        <Typography variant="body1">Please provide a reason for leaving the activity.</Typography>
        <TextField
          label="Reason for Leaving"
          multiline
          rows={4}
          fullWidth
          variant="outlined"
          value={leaveReason}
          onChange={e => setLeaveReason(e.target.value)}
          sx={{ marginTop: '16px' }}
        />
      </div>
      <DialogActions sx={{p:2}}>
        <Button onClick={handleCancel} sx={{
            color: isDarkMode ? '#FFCE00' : '#674BFF',
 
            '&:hover': {
              color: isDarkMode ? '#FFCE00' : '#674BFF',
            },
          }}>
          Cancel
        </Button>
        <Button disabled={loading} onClick={handleReport} sx={{
            backgroundColor: isDarkMode ? '#FFCE00' : '#674BFF',
          color: isDarkMode ? "black":'#ffff',
            '&:hover': {
              backgroundColor: isDarkMode ? '#FFCE00' : '#674BFF',
             
            },
          }}
          variant="contained">
          Leave
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeaveActivityRecurringDialog;
